import { INITIALIZE_PAYSTACK_TRANSACTION } from "../../actions/actionTypes";

const initializePaystackTransactionReducer = (state, action) => {
    let accessCode = action.payload.accessCode || "";
    let updatedState = {
        ...state,
        accessCode
    };
    return updatedState;
}

export const paystackReducer = (state = {}, action) => {
    switch(action.type){
        case INITIALIZE_PAYSTACK_TRANSACTION:
            return initializePaystackTransactionReducer(state, action);
        default:
            return state;
    }
}